import { render, staticRenderFns } from "./base-search-select.vue?vue&type=template&id=04f01004&"
import script from "./base-search-select.vue?vue&type=script&lang=js&"
export * from "./base-search-select.vue?vue&type=script&lang=js&"
import style0 from "./base-search-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports